import dynamic from "next/dynamic";
import styles from './searchData.module.css'
import AtAGlance from "./AtAGlance";
import News from "../News";
import { Suspense } from "react";
import globalStyles from '../search.module.css';
import Link from "next/link";

const Recommendations = dynamic(() => import("./Recommendations"), {
  ssr: true,
});

type Props = {
  title?: string, 
  statistics: statisticsProps, recommendations: object, destination: object | null, searchType: string, categoryCode: string, locationDetails: object, searchCriteria: string, portfolio: {name: string}, news: [], forSale: boolean 
}

type statisticsProps = {
  rent_max: number;
  size_max: string;
  cats: { [key: string]: number; };
  topAgent: { agent: string; amount: number; };
  rent_minium: number;
  rent_medium: number;
  rent_avg: string | null;
  size_minium: string;
  prive_avg: string;
  price_medium: number;
  price_max: number;
  price_minium: number;
  total: number
  availability: object,
  name: string,
  uri: string
}

const SearchData = ({ title, statistics, recommendations, destination = null, searchType, categoryCode, locationDetails, searchCriteria, portfolio, news, forSale = false }: Props) => {
  const { name, uri } = statistics || { name: null, uri: null };
  // only render if we have location details
  let isGoogleSearch = !!title;
  let locationName = title || name;
  if (!name) return null;
  return (
    <Suspense>
      <div className={styles.wrapper} id='searchData'>
        <div className={styles.innerWrapper}>

          <Recommendations recommendations={recommendations} name={locationName} searchType={searchType}
            categoryCode={categoryCode} forSale={forSale} />

          {((!forSale && statistics?.availability?.['For Sale'] && statistics.availability['For Sale'] > 0) || (forSale && statistics?.availability?.['To Let'] && statistics.availability['To Let'] > 0)) && (
            <div className={`${globalStyles.lookingForBox} ${styles.extraPad}`}> 
              <div>
                <h2>{!forSale ? 'Only looking for shops for sale?' : 'Only looking for shops to rent?'}</h2>
                <p>We have {!forSale ? statistics.availability['For Sale'] : statistics.availability['To Let']} {!forSale ? 'for sale' : 'for rent'} in {locationName}, take a look!</p>
              </div>
              <Link href={`/${!forSale ? 'shops-for-sale' : 'shops-to-rent'}/${uri}`} passHref prefetch={false} >
                <button className={globalStyles.secondaryButton}>{!forSale ? 'Search shops for sale' : 'Search shops for rent'}</button>
              </Link>
            </div>
          )}

          {statistics && Boolean(statistics.total) && (
            <h2 className={styles.mlmd0}>{`Information about retail space in ${locationName}`}</h2>
          )}
          {statistics && Boolean(statistics.total) && <AtAGlance rent_max={statistics.rent_max} size_max={statistics.size_max} cats={statistics.cats} topAgent={statistics.topAgent} rent_minimum={statistics.rent_minium} rent_medium={statistics.rent_medium} rent_avg={statistics.rent_avg} size_minimum={statistics.size_minium} price_avg={statistics.prive_avg} price_medium={statistics.price_medium} price_max={statistics.price_max} price_minimum={statistics.price_minium} title={locationName} isGoogleSearch={isGoogleSearch} searchType={searchType} searchCriteria={searchCriteria}
          portfolio={portfolio} forSale={forSale} total={statistics.total} availability={statistics.availability} name={statistics.name}       />}

          {news && news.length > 0 && (
            <News locationName={locationName} newsArticles={news} searchCriteria={searchCriteria} />
          )}
          {/* <Ads /> */}
        </div>
      </div>
    </Suspense>
  );
};

export default SearchData;
